export default __webpack_public_path__ + "static/media/empty-daily-teams-capacity-list.830d7239.svg";